import { mergePlain } from 'util/merge'
import { doGraphqlRequest } from 'ducks/requests/operations'
import { buildId, getRawId } from 'util/globalId'
import { selectCurrentUserGlobalId } from 'ducks/currentUser/selectors/selectCurrentUserGlobalId'
import { emptyArr, uniq } from 'util/arrays'
import GA from 'util/googleAnalytics'
import { UPDATE_CONVERSATION_FOLLOW } from '../actionTypes'
import { updateFollowConversationdMutation } from '../mutations'
import { CONVERSATION_SAVE_UNLOAD_MESSAGE } from '../constants'
import { conversationFollowGraphQlResponseSchema } from '../schema'
import { selectCurrentConversationById } from '../selectors'
import { onUpdateAttachEventGroupIdToEvents } from '../utils/request'

export const doFollow = (ticketId, options = {}) => (dispatch, getState) => {
  const conversationId = buildId('Conversation', ticketId)

  const state = getState()
  const ticket = selectCurrentConversationById(state, ticketId)
  const currentUserGid = selectCurrentUserGlobalId(state)
  const currentFollowers = ticket?.followers || emptyArr

  // Check if user is already following using normalized IDs to handle format differences
  const currentUserRawId = getRawId(currentUserGid)
  const isAlreadyFollowing = currentFollowers.some(
    followerId => getRawId(followerId) === currentUserRawId
  )

  if (!ticket || isAlreadyFollowing) return null

  const updatedConversation = {
    ...ticket,
    followers: uniq([...currentFollowers, currentUserGid]),
  }

  if (options.trackType) {
    GA.track(options.trackType, 'Clicked', 'Follow ticket')
  }

  return dispatch(
    doGraphqlRequest(
      UPDATE_CONVERSATION_FOLLOW,
      updateFollowConversationdMutation(),
      {
        conversationId,
        followerIds: [currentUserGid],
      },
      mergePlain(
        {
          app: true,
          throwOnError: true,
          concurrency: {
            key: ticketId,
            message: CONVERSATION_SAVE_UNLOAD_MESSAGE,
          },
          normalizationSchema: conversationFollowGraphQlResponseSchema,
          transformResponse: onUpdateAttachEventGroupIdToEvents(
            'conversationFollow'
          ),
          optimist: {
            entities: {
              conversation: {
                [ticketId]: updatedConversation,
              },
            },
          },
          moduleOptions: {
            snackbar: {
              enabled: true,
              success: {
                enabled: true,
                message: `${app.t('Ticket')} followed`,
              },
              failed: {
                enabled: true,
                message: `Oops, we couldn't follow your ${app.t('ticket')}.`,
              },
            },
          },
          meta: {
            mergeEntities: true,
          },
        },
        options
      )
    )
  )
}
